import { padStart } from 'lodash'

/**
 * 补足数字位数
 * @param digit 数字
 * @param len 位数
 */
export const fillDigit = (digit: number, len: number) => {
  return padStart('' + digit, len, '0')
}

/**
 * 判断设备
 */
export const isPC = () => {
  return !navigator.userAgent.match(/(iPhone|iPod|iPad|Android|Mobile|BlackBerry|Symbian|Windows Phone)/i)
}

/**
 * 判断URL字符串
 */
export const isValidURL = (url: string) => {
  return /^(https?:\/\/)([\w-]+\.)+[\w-]{2,}(\/[\w-./?%&=]*)?$/i.test(url)
}

/**
 * HTML转纯文本
 */
export const htmlToText = (html: string) => {
  const doc = new DOMParser().parseFromString(html, 'text/html')
  return doc.body.textContent || ''
}

/**
 * 判断模板是否为 VIP 专享
 */
export const isVipTemplate = (item?: { vipExclusive?: unknown } | null) => {
  const value = item?.vipExclusive
  return value === true || value === 1 || value === '1' || value === 'true'
}

/**
 * 获取数据中指定的类型
 */
export const getDataByType = <
  T extends { type?: string; [key: string]: any }
>(
  sourceData: { coverList?: T[] } | null | undefined,
  type: string
): T | null => {
  if (!sourceData || !type) {
    return null
  }
  return sourceData.find((item) => item?.type === type)?.url || null
}
